import { useSelector } from "react-redux";
import { selectAccountBookSettings } from "../../../../../store/selectors/clientSettingsSelectors";
import type { DrillDownPage } from "../../../../../store/types/drillDownPageState.types";
import ChartOfAccountsListContainer from "./ChartOfAccountsListContainer";
import ChartOfAccountsMultiBookListContainer from "./ChartOfAccountsMultiBookListContainer";
import type { ChartOfAccountsLedgerItem, DrillDownInfo } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  configuration: DrillDownPage;
  info: DrillDownInfo;
  chartOfAccounts: ChartOfAccountsLedgerItem[];
}
const LedgerAccountsWrapper = (props: Props) => {
  const accountingBookSettings = useSelector(selectAccountBookSettings);

  return (
    <>
      {!accountingBookSettings?.multiBook && <ChartOfAccountsListContainer {...props} />}
      {accountingBookSettings?.multiBook && <ChartOfAccountsMultiBookListContainer {...props} />}
    </>
  );
};

export default LedgerAccountsWrapper;
